(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["poseidon-size-guide"] && !Shopify.designMode) return;
  try {
    (() => {
    const movePoseidonSizeGuide = () => {
      document.querySelectorAll('.poseidon-size-guide').forEach((guide) => {
        const details = guide.closest('.product-details');
        const picker = details?.querySelector('variant-picker[data-template-product-match="true"]') || details?.querySelector('variant-picker');
        if (picker && picker.parentElement) {
          picker.parentElement.insertBefore(guide, picker.nextSibling);
        }
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', movePoseidonSizeGuide, { once: true });
    } else {
      movePoseidonSizeGuide();
    }

    document.addEventListener('shopify:section:load', movePoseidonSizeGuide);
  })();
  } catch(e) { console.error(e); }
})();

})();
